import React, { forwardRef, useMemo } from 'react';

import { AnimatePresence, motion } from "framer-motion"

import Paper from '@mui/material/Paper';
import { styled } from '@mui/system';

const CustomPaper = styled(Paper)(({ theme }) => {
  return {
    backgroundColor: theme.palette.menu.background.dark,
    borderRadius: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '60',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  }
})

const PaperRef = forwardRef((props, ref) => (
  <CustomPaper {...props} ref={ref} />
))

const AnimatedPaper = motion(PaperRef, { forwardMotionProps: false })

const loaderAnimation = {
  entry: (custom) => {
    return {
      clipPath: `circle(150% at ${custom.top}${custom.unitOfMeasure} ${custom.left}${custom.unitOfMeasure})`,
      transition: {
        type: "spring",
        stiffness: 200,
        damping: 40,
      }
    }
  },
  exit: (custom) => {
    return {
      clipPath: `circle(0% at ${custom.top}${custom.unitOfMeasure} ${custom.left}${custom.unitOfMeasure})`,
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 40,
      }
    }
  }
};

const ModuleLoader = ({ suspenseMounted }) => {

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const top = useMemo(() => (Math.random() * (120) - 10).toFixed(4), [suspenseMounted])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const left = useMemo(() => (Math.random() * (120) - 10).toFixed(4), [suspenseMounted])
  const unitOfMeasure = useMemo(() => '%', [])

  return (
    <AnimatePresence initial={false}>
      <AnimatedPaper variants={loaderAnimation} custom={{ top, left, unitOfMeasure }} initial='initial' animate={suspenseMounted ? 'entry' : 'exit'} exit='exit' />
    </AnimatePresence>
  )
}

export default ModuleLoader